import { PriceFrequency } from '@energy-retailer/constants';

import type { EstimatesSchema } from '@energy-retailer/schema';

type GetProductPlanEstimatedPriceParams = {
  estimates: EstimatesSchema;
  priceFrequency?: PriceFrequency;
};

const getProductPlanEstimatedPrice = ({
  estimates,
  priceFrequency = PriceFrequency.Yearly,
}: GetProductPlanEstimatedPriceParams): string => {
  // TODO: switch load?
  switch (priceFrequency) {
    case PriceFrequency.Yearly:
      return estimates.annual;
    case PriceFrequency.Quarterly:
      return estimates.quarterly;
    case PriceFrequency.Monthly:
      return estimates.monthly;
    case PriceFrequency.Weekly:
      return estimates.weekly;
    default:
      return estimates.annual;
  }
};

export { getProductPlanEstimatedPrice };
